<template>
  <div class="wrapper">
    <span class="w-title">个人中心</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="form-panel">
        <div class="form-panel-head">基本信息</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>用户名:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.username"
                  v-model="item.username"
                  label="请输入用户名"
                  :rules="[rules.required, rules.length5]"
                  outline
                  solo
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>邮箱:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.email"
                  v-model="item.email"
                  :rules="[rules.email]"
                  label="请输入邮箱"
                  outline
                  solo
                ></v-text-field>
              </v-flex>

              <v-flex xs3 md2 class="d-flex mt-2">
                <label class="required">姓名:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.name"
                  v-model="item.name"
                  label="请输入姓名"
                  :rules="[rules.required]"
                  outline
                  solo
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label class="required">联系方式:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.phoneNumber"
                  v-model="item.phoneNumber"
                  label="请输入联系方式"
                  :rules="[rules.required,rules.phoneNumber]"
                  outline
                  solo
                ></v-text-field>
              </v-flex>

              <v-flex v-if="item.role === 'user'" xs3 md2 class="d-flex mt-2">
                <label class="required">公司:</label>
              </v-flex>
              <v-flex v-if="item.role === 'user'" xs9 md4>
                <v-autocomplete
                  ref="form.companyId"
                  v-model="item.companyId"
                  no-data-text="无可用数据"
                  :items="companies"
                  label="请选择公司"
                  :rules="[
                    () => item.role !== 'user' || item.companyId !== null || '必选'
                  ]"
                  outline
                  solo
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <div class="form-panel-head" style="display: flex;align-items: center;justify-content: space-between">
          账号安全
          <v-checkbox
            v-model="item.wantToChange"
            primary
            hide-details
            label="修改密码"
            style="display: contents"
          ></v-checkbox>
        </div>
        <div class="form-panel-body">
          <v-container v-if="item.wantToChange" fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label class="required">密码:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.password"
                  v-model="item.password"
                  :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                  :type="showPassword ? 'text' : 'password'"
                  label="请输入密码"
                  hint="长度至少为8"
                  :rules="[rules.length8]"
                  outline
                  solo
                  @click:append="showPassword = !showPassword"
                  @change="changePassword"
                  @focusout="changePassword"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-container>

    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-btn color="info" @click="save">保存</v-btn>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {mapState, mapActions} from "vuex";
  import axios from "../axios";

  export default {
    name: "UserForm",
    components: {

    },
    data: () => ({
      rules: {
        required: value => !!value || "必填",
        length5: value => (!!value && value.length >= 5) || "长度至少为5",
        length8: value => (!!value && value.length >= 8) || "长度至少为8",
        phoneNumber: value => {
          const pattern = /^1\d{10}$/;
          return pattern.test(value) || "请输入正确的手机号";
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          // eslint-disable-next-line
          return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的邮箱";
        }
      },
      showPassword: false,
      hasErrors: false,
      item: {}
    }),
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        companies: state => state.miniCompanies,
        companiesMap: state => state.miniCompaniesMap
      }),
      rolesItems() {
        if (this.currentUser.role === "admin") {
          return [
            {value: "admin", text: "管理员"},
            {value: "firm", text: "员工用户"},
            {value: "user", text: "普通用户"}
          ];
        } else if (this.currentUser.role === "firm") {
          return [
            {value: "firm", text: "员工用户"},
            {value: "user", text: "普通用户"}
          ];
        } else {
          return [{value: "user", text: "普通用户"}];
        }
      }
    },
    methods: {
      ...mapActions(["setLoading"]),
      changePassword() {
        if (this.item.password === '' || (!this.item.password)) {
          if (
            this.$refs["form.password"] !== null &&
            typeof this.$refs["form.password"] !== "undefined"
          ) {
            this.$refs["form.password"].resetValidation();
            delete this.item.password;
          }
        }
      },
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },
      cancel() {
        //this.$router.back();
        this.$router.push({name: 'home'});
      },
      save() {
        this.validate();
        if (!this.hasErrors) {
          if (!this.item.wantToChange) {
            delete this.item.password;
          }
          this.setLoading(true);
          axios
            .put("/users/me", this.item)
            .then(() => {
              this.setLoading(false);

              this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
                //this.$router.back();
                this.$router.push({name: 'home'});
              });
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {
                buttonFalseText: null
              });
              this.setLoading(false);
            });
        }
      },
      validate() {
        this.hasErrors = false;

        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      }
    },
    created() {
      this.setLoading(true);
      axios.get("/users/me").then(res => {
        this.item = res.data;
        this.setLoading(false);
      })
        .catch(reason => {
          this.$confirm(reason.response.data.message, {
            buttonFalseText: null
          });
          this.setLoading(false);
        });
    }
  };
</script>

<style scoped></style>
